// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch[data-id] {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}
.switch[data-id] input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch[data-id] label {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #575757;
  border-radius: 20px;
  transition: background-color 0.2s;
}
.switch[data-id] label::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.switch[data-id] input:checked + label {
  background-color: #00be85;
}
.switch[data-id] input:checked + label::before {
  transform: translateX(20px);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/switch.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AACJ;AAEE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iCAAA;AAAJ;AAEI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;AAAN;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,2BAAA;AAHJ","sourcesContent":[".switch[data-id] {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  label {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #575757;\n    border-radius: 20px;\n    transition: background-color 0.2s;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 2px;\n      top: 2px;\n      width: 20px;\n      height: 20px;\n      background-color: #fff;\n      border-radius: 50%;\n      transition: transform 0.2s;\n    }\n  }\n\n  input:checked + label {\n    background-color: #00be85;\n  }\n\n  input:checked + label::before {\n    transform: translateX(20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
